export default __webpack_public_path__ + "static/media/be-sure-stepsliide4.642e1e57.png";